@let parentCategoryDropdownItemsValue = parentCategoryDropdownItems();
@let campTypeDropdownItemsValue = campTypeDropdownItems();
@let isBusyValue = isBusy();
@let selectedCampTypesValue = selectedCampTypes();
@let selectedParentCategoriesValue = selectedParentCategories();

<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-camp-options-selector
                hznTestId="manage-images-options-selector"
                [parentCategoryDropdownItems]="parentCategoryDropdownItemsValue"
                [campTypeDropdownItems]="campTypeDropdownItemsValue"
                [isBusy]="isBusyValue"
                (campTypesChanged)="onCampTypesChanged($event)"
                (parentCategoriesChanged)="onParentCategoriesChanged($event)"
            ></app-camp-options-selector>
        </div>
        <div class="col p-2">
            <app-category-image-manager hznTestId="manage-images-image-manager" [selectedParentCategories]="selectedParentCategoriesValue" [selectedCampTypes]="selectedCampTypesValue"> </app-category-image-manager>
        </div>
    </div>
</div>
